
<template>
  <div class="vip_box">
    <span class="icon_succ"
          :class="{'icon_fail':status == '0'}"></span>
    <p class="pay_succ">{{title}}</p>
  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
      title: '',
      status: '1',
      productId: '',
      timer: null,
      url: ''
    }
  },
  mounted () {
    this.productId = this.$route.query.productId;
    // this.status = this.$route.query.status;
    this.title = '认证成功'
    this.util.title('认证成功');
    this.getPost();
  },
  methods: {
    //调用android和ios的方法
    toProductDetail () {
      let json = {
        "pageUrl": this.url
      }
      try {
        window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
      } catch (err) {
        window.AppJs.toProductDetail(JSON.stringify(json));//android
      }
    },
    getPost () {
      let _this = this;
      let param = {
        productId: this.productId
      };
      this.$post('/app/v1/operator/hasSuccess', param).then(res => {
        if (res.code == 200) {
          let i = 5;
          _this.timer = setInterval(function () {
            i--;
            if (i == 1) {
              _this.url = res.data.pageUrl;
              _this.toProductDetail()
            }
          }, 1000)
        } else {
          _this.util.toast({ msg: res.message, type: 'fail' })
        }
      });
    }

  }

}
</script>
<style scoped>
.vip_box {
  text-align: center;
  padding-top: 0.68rem;
  /* box-shadow: 0px 1px 0px 0px rgba(255, 0, 0, 1); */
}
.icon_succ,
.icon_fail {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
  background: url('../../assets/img/vip/success.png') no-repeat center center;
  background-size: 100% 100%;
}
.icon_fail {
  background: url('../../assets/img/vip/fail.png') no-repeat center center;
  background-size: 100% 100%;
}
.pay_succ {
  color: #333333;
  font-size: 0.2rem;
}
</style>
